import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebaseConfig';
import QuestionDisplay from './QuestionDisplay';
import Scorecard from './Scorecard';
import { Button } from '@mui/material';
import './game.css';

function getJoinUrl() {
  if (typeof window === 'undefined') {
    return 'https://placeholder.com';
  }

  const url = new URL(window.location.href);
  url.hash = '';
  return url.href.replace(/\/$/, '');
}

function getDisplayJoinUrl(joinUrl) {
  try {
    const url = new URL(joinUrl);
    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
      return 'placeholder.com';
    }

    return `${url.host}${url.pathname}`.replace(/\/$/, '');
  } catch {
    return 'placeholder.com';
  }
}

const App = () => {
  const [isTriviaOn, setIsTriviaOn] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(false);
  const [isShowScorecard, setIsShowScorecard] = useState(false);
  const joinUrl = getJoinUrl();
  const displayJoinUrl = getDisplayJoinUrl(joinUrl);
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(joinUrl)}`;

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {
      const data = doc.data();
      setIsTriviaOn(Boolean(data?.isOn))
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "currentQuestion", "UEsaFssIIvcTBHM9hejH"), (doc) => {
      const data = doc.data();
      setCurrentQuestion(data?.id || "")
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isShowScorecard", "MQyyHk4Q8g1UonUg7ZNc"), (doc) => {
      const data = doc.data();
      setIsShowScorecard(Boolean(data?.isShowScorecard))
    });
    return () => unsub();
  }, []);

  return (
    <div className="game-shell">
      {
        isShowScorecard &&
        <Scorecard></Scorecard>
      }
      {
        !isShowScorecard && <>
          {
            (!isTriviaOn || (isTriviaOn && !currentQuestion)) &&
            <div className="game-stage">
              <div className="game-panel game-lobby">
                <div>
                  <p className="game-kicker">Caltrans History Trivia Ride</p>
                  <h1 className="game-title">Are we there yet?</h1>
                  <p className="game-subtitle">Join on your phone, enter your name, and get ready for a ride through California transportation history.</p>
                </div>
                <div className="join-panel">
                  <div className="join-url">{displayJoinUrl}</div>
                  <img className="join-qr" alt={`QR code for ${displayJoinUrl}`} src={qrCodeUrl} />
                  <Button size="large" variant="contained">Start</Button>
                  <span>Then enter your name and save.</span>
                </div>
              </div>
            </div>
          }
          {
            isTriviaOn && currentQuestion && <>
              <QuestionDisplay></QuestionDisplay>
            </>
          }
        </>
      }
    </div>
  );
};

export default App;
